window.ldfetch = require('./ldfetch.js');
